// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2-b-h","header":"ReportDetails_header__2AgRW","title":"ReportDetails_title__3aSIq","left":"ReportDetails_left__An9mu"};